import * as React from 'react';
import { SVGProps } from 'react';

const FileIconPptSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 34 40" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M32 0H2a2 2 0 0 0-2 2v36a2 2 0 0 0 2 2h30a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Z" />
    <path opacity={0.6} d="M25 24a7.001 7.001 0 0 0-7-7v7h7Z" fill="#fff" />
    <path opacity={0.6} d="M22 26a6 6 0 1 1-6-6v6h6Z" stroke="#fff" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.27 11.67c.18.22.44.33.78.33H23v-1h-.55c-.153 0-.267-.03-.34-.09-.073-.06-.11-.163-.11-.31V8h1V7h-1V6h-1v1h-1v1h1v2.8c0 .36.09.65.27.87ZM10.8 7.24V7H10v7h1.01v-2h1.29c.58 0 1.007-.127 1.28-.38.28-.253.42-.66.42-1.22V8.6c0-.567-.137-.973-.41-1.22-.273-.253-.703-.38-1.29-.38h-.7c-.327 0-.593.08-.8.24Zm.36.94c.107-.12.27-.18.49-.18h.6c.247 0 .433.057.56.17.127.113.19.273.19.48v1.7c0 .207-.063.367-.19.48-.127.113-.313.17-.56.17h-1.24L11 8.55a.53.53 0 0 1 .16-.37Zm4.63-.94V7h-.8v7H16v-2h1.29c.58 0 1.007-.127 1.28-.38.28-.253.42-.66.42-1.22V8.6c0-.567-.137-.973-.41-1.22-.273-.253-.703-.38-1.29-.38h-.7c-.327 0-.593.08-.8.24Zm.36.94c.107-.12.27-.18.49-.18h.6c.247 0 .433.057.56.17.127.113.19.273.19.48v1.7c0 .207-.063.367-.19.48-.127.113-.313.17-.56.17H16l-.01-2.45a.53.53 0 0 1 .16-.37Z"
      fill="#fff"
    />
  </svg>
);
export default FileIconPptSizeM;
